var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 5.16684C3.33325 4.61455 3.78097 4.16684 4.33325 4.16684H16.3333C16.8855 4.16684 17.3333 4.61455 17.3333 5.16684C17.3333 5.71912 16.8855 6.16684 16.3333 6.16684H4.33325C3.78097 6.16684 3.33325 5.71912 3.33325 5.16684Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 10.1668C3.33325 9.61455 3.78097 9.16684 4.33325 9.16684H16.3333C16.8855 9.16684 17.3333 9.61455 17.3333 10.1668C17.3333 10.7191 16.8855 11.1668 16.3333 11.1668H4.33325C3.78097 11.1668 3.33325 10.7191 3.33325 10.1668Z",
    fill: "#23242A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 15.1668C3.33325 14.6146 3.78097 14.1668 4.33325 14.1668H10.3333C10.8855 14.1668 11.3333 14.6146 11.3333 15.1668C11.3333 15.7191 10.8855 16.1668 10.3333 16.1668H4.33325C3.78097 16.1668 3.33325 15.7191 3.33325 15.1668Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongText);
export default __webpack_public_path__ + "static/media/long-text.65a72e56a2e3f115cb33a1d1b6247bb6.svg";
export { ForwardRef as ReactComponent };